export default __webpack_public_path__ + "static/media/ART4.0973feac.jpg";